import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8def95401ce4598/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8def95401ce4598/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8def95401ce4598/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8def95401ce4598/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8def95401ce4598/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/app/[locale]/branches/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
